import { Injectable } from '@angular/core';

import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SalesReportByGroupService {

  constructor(private http: HttpClient) { }

exportSalesReport(data: any): Observable<any> {
    return this.http.post(
      environment.baseUrl + '/shop/reports/sales-report',
      data,
      { responseType: 'blob' }
    ).pipe(
      catchError(error => {
        console.log('Raw API error:', error); // Log raw error
        if (error.status === 0) {
          return throwError(() => new Error('Network error occurred'));
        }

        return new Observable(observer => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              console.log('Parsed error JSON:', errorJson); // Log parsed JSON
              if (errorJson.data && Array.isArray(errorJson.data) && errorJson.data.length === 0) {
                observer.error(new Error('No data found'));
              } else {
                observer.error(new Error(errorJson.message || 'Failed to generate report'));
              }
            } catch (e) {
              console.error('JSON parse error:', e); // Log parse failure
              observer.error(new Error('Failed to process error response'));
            }
            observer.complete();
          };
          reader.onerror = () => {
            console.error('FileReader error:', error.error); // Log reader error
            observer.error(new Error('Failed to read error response'));
            observer.complete();
          };
          reader.readAsText(error.error);
        });
      })
    );
  }

  
}
